// extracted by mini-css-extract-plugin
export default {"Container":"Loading_Container__hozMr","Text":"Loading_Text__XtMdR","ShowOpacity":"Loading_ShowOpacity__Chcrh"};